export default __webpack_public_path__ + "static/media/intro-web.57c0d056.jpg";